import React, { useEffect, useRef, useState } from "react";
import { Card, Spinner, Form, Row, Col } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonGroup } from "@themesberg/react-bootstrap";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { fetchApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";
import moment from "moment";

const headerColors = [
  "#999", "#ccc", "#eee", "#f2f2f2", "#f5f5f5", "#f9f9f9",
];

function unflattenTable(arr) {
  var tree = [],
    mappedArr = {},
    arrElem, mappedElem;

  for (var i = 0, len = arr?.length; i < len; i++) {
    arrElem = arr[i];
    if (arrElem?.code) {
      mappedArr[arrElem.code] = { ...arrElem, parentHeads: [], children: [] };
    }
  }

  for (i = 0; i < len; i++) {
    arrElem = arr[i];
    mappedElem = mappedArr[arrElem.code];

    if (mappedElem) {
      const parentHeads = [];
      let currentParent = mappedElem;
      while (currentParent?.sub_head) {
        parentHeads.unshift(currentParent?.sub_head);
        currentParent = mappedArr[currentParent?.sub_head];
      }
      mappedElem.parentHeads = parentHeads;

      if (mappedElem?.sub_head) {
        if (mappedArr[mappedElem.sub_head]) {
          mappedArr[mappedElem.sub_head].children.push(mappedElem);
        } else {
          tree.push(mappedElem);
        }
      } else {
        tree.push(mappedElem);
      }
    }
  }

  return tree;
}

const options = [
  { value: "total_ex_by_admin", title: "Total Exp. by Admin", code: null },
  { value: "ex_by_admin_new", title: "Personnel Exp. by Admin", code: "Personnel" },
  { value: "ex_by_admin_new", title: "Other NDR Exp. by Admin", code: "OverHead" },
  { value: "ex_by_admin", title: "Debt Service by Admin", code: "02%" },
  { value: "ex_by_admin_new", title: "Capital Exp. by Admin", code: "Capital" },
];

function getLikeCode(option) {
  if (!option.code) return null;
  if (option.code === "Personnel") return "21%";
  if (option.code === "OverHead") return "22%";
  if (option.code === "Capital") return "32%";
  return option.code;
}

const isEmpty = (v) =>
  v === 0 || v === null || v === undefined || v === "--" || v === "0.00" || v === "";

export default function ExpenditureByAdmin() {
  const [treeData, setTreeData] = useState([]);
  const [form, setForm] = useState({
    budget_year: moment().format("YYYY"),
  });
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const years = Array.from({ length: 10 }, (_, i) =>
    moment().format("YYYY") - i
  );
  const tableRef = useRef(null);

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleButtonClick = (item) => {
    setSelectedOption(item);
  };

  useEffect(() => {
    setLoading(true);
    const likeCode = getLikeCode(selectedOption);
    const url = `reports?query_type=${selectedOption.value}&budget_year=${form.budget_year}${likeCode ? `&like=${likeCode}` : ""}`;
    fetchApi(url)
      .then((data) => {
        const rows = data?.results || [];
        const tt = unflattenTable(rows);
        setTreeData(tt);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [form.budget_year, selectedOption]);

  const ensureNumber = (value) =>
    isNaN(value) || value === null || value === undefined ? 0 : Number(value);

  const calcSum = (node, key) => {
    if (!node.children || node.children.length === 0) {
      return ensureNumber(node[key]);
    }
    let sum = ensureNumber(node[key]);
    for (const child of node.children) {
      sum += calcSum(child, key);
    }
    return sum;
  };

  const newFilter = (item) =>
    ["prev_year2_actual_amount", "prev_year1_approve_amount", "prev_year1_actual_amount", "budget_amount", "supplementary_amount", "approve_amount"]
      .every((k) => isEmpty(item[k]));

  const newFilterHead = (item) =>
    ["prev_year2_actual_amount", "prev_year1_approve_amount", "prev_year1_actual_amount", "budget_amount", "supplementary_amount", "approve_amount"]
      .every((k) => isEmpty(calcSum(item, k)));

  const renderItems = (item, index) => (
    <React.Fragment key={`group_${index}`}>
      {!newFilterHead(item) && (
        <tr
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "black",
            cursor: "pointer",
          }}
        >
          <td
            style={{
              backgroundColor: headerColors[item.parentHeads?.length] || "",
              color: "black",
            }}
          >
            {item.code?.replace(/0+$/, "")}
          </td>
          <td
            style={{
              backgroundColor: headerColors[item.parentHeads?.length] || "",
              color: "black",
            }}
          >
            {item.description}
          </td>
          {["prev_year2_actual_amount", "prev_year1_approve_amount", "prev_year1_actual_amount", "budget_amount", "supplementary_amount", "approve_amount"].map((k) => (
            <td
              key={k}
              style={{
                textAlign: "right",
                backgroundColor: headerColors[item.parentHeads?.length] || "",
                color: "black",
              }}
            >
              {k === "supplementary_amount" && isNaN(calcSum(item, k))
                ? "---"
                : formatNumber(calcSum(item, k))}
            </td>
          ))}
        </tr>
      )}
      {item.children?.map((child, idx) => {
        if (child.children?.length) {
          return renderItems(child, idx);
        }
        if (newFilter(child)) return null;
        return (
          <tr key={child.code || idx} style={{ fontSize: "11px" }}>
            <td>{child.code}</td>
            <td>{child.description}</td>
            {["prev_year2_actual_amount", "prev_year1_approve_amount", "prev_year1_actual_amount", "budget_amount", "supplementary_amount", "approve_amount"].map((k) => (
              <td key={k} style={{ textAlign: "right" }}>
                {k === "supplementary_amount" && isNaN(ensureNumber(child[k]))
                  ? "---"
                  : formatNumber(child[k])}
              </td>
            ))}
          </tr>
        );
      })}
    </React.Fragment>
  );

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>{selectedOption.title}</h4>
        </div>
      </div>

      <Card border="light" className="shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Budget Year</Form.Label>
                <Form.Select
                  name="budget_year"
                  value={form.budget_year}
                  onChange={handleChange}
                >
                  <option>--select--</option>
                  {years.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6} className="text-center">
              <ButtonGroup>
                {options.map((item) => (
                  <Button
                    size="sm"
                    key={item.title}
                    variant={
                      selectedOption.title === item.title
                        ? "primary"
                        : "outline-secondary"
                    }
                    onClick={() => handleButtonClick(item)}
                  >
                    <small>{item.title}</small>
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
            <Col
              md={3}
              className="d-flex align-items-end justify-content-end"
            >
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => {
                  if (tableRef.current) {
                    const ws = XLSX.utils.table_to_sheet(tableRef.current);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Expenditure by Admin");
                    const buf = XLSX.write(wb, {
                      bookType: "xlsx",
                      type: "array",
                    });
                    FileSaver.saveAs(
                      new Blob([buf], {
                        type: "application/octet-stream",
                      }),
                      `${selectedOption.title}.xlsx`
                    );
                  }
                }}
              >
                <FontAwesomeIcon icon={faFileDownload} className="me-1" />{" "}
                Download Excel
              </Button>
            </Col>
          </Row>

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="table-responsive">
              <table
                className="table table-bordered"
                ref={tableRef}
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      backgroundColor: "orange",
                    }}
                  >
                    <th style={{ backgroundColor: "orange" }}>Code</th>
                    <th style={{ backgroundColor: "orange" }}>Description</th>
                    <th style={{ backgroundColor: "orange" }}>{`${
                      parseInt(form.budget_year) - 2
                    } Full Year Actuals`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${
                      parseInt(form.budget_year) - 1
                    } Approved`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${
                      parseInt(form.budget_year) - 1
                    } Performance Jan. to Aug.`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${parseInt(
                      form.budget_year
                    )} MDA Proposal`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${parseInt(
                      form.budget_year
                    )} Adjustments`}</th>
                    <th style={{ backgroundColor: "orange" }}>{`${parseInt(
                      form.budget_year
                    )} Approved Budget`}</th>
                  </tr>
                </thead>
                <tbody>
                  {treeData.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center py-4">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    treeData.map((item, i) => renderItems(item, i))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
